module.exports = __webpack_public_path__ + "static/media/circuito.6a6c8a9a.webp";